import { InfoOutlined as InfoIcon } from "@mui/icons-material";
import { Stack, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { PimProductPreferenceScope } from "../../../../clients/graphqlTypes.js";

interface Props {
  value: PimProductPreferenceScope;
  onChange: (scope: PimProductPreferenceScope) => void;
  counts: Record<PimProductPreferenceScope, number>;
}

/** Switches the list between the caller's own preferences and their organisation's. */
export function PreferenceScopeToggle({ value, onChange, counts }: Props) {
  const { t } = useTranslate(["Product", "Global"]);

  return (
    <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={value}
        onChange={(_, next: PimProductPreferenceScope | null) => {
          // Exclusive groups report `null` when the active button is clicked again.
          if (next !== null) onChange(next);
        }}
      >
        <ToggleButton value="USER">
          {`${t("Mine", { ns: "Global" })} (${counts.USER})`}
        </ToggleButton>
        <ToggleButton value="ORGANISATION">
          {`${t("Organisation", { ns: "Product" })} (${counts.ORGANISATION})`}
        </ToggleButton>
      </ToggleButtonGroup>
      <Tooltip
        title={t("Your own preferences rank above your organisation's.", {
          ns: "Product",
        })}
      >
        <InfoIcon
          fontSize="small"
          sx={{ color: "grey.600" }}
          aria-label={t(
            "Your own preferences rank above your organisation's.",
            { ns: "Product" }
          )}
          role="img"
        />
      </Tooltip>
    </Stack>
  );
}
